import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { Button, Col, Container, Row } from 'react-bootstrap';
import moment from 'moment-timezone';
import Select from "react-select";
import { leftSideToggle } from '../../../actions/user';
import { dateToUTC, secondsToTime, toDisplayTimeString } from '../../../helpers/moment-ex';
import { getEGRegionLocation, getEGRegionLocationLog, getEquipmentGroupList, getGeoRegionList } from '../../../actions/equipment-group';
import { getDeviceList } from '../../../actions/hardware';
import { DISPLAY_DATETIMESECONDS_FORMAT2, DISPLAY_DATE_WITH_MIN_SEC_MSEC } from '../../../constants';
import { Workbook } from 'react-excel-workbook';
import { ToggleSwitch } from '../../widgets';

const EgRegionLocation = () => {

  const dispatch = useDispatch();
  const params = useParams();
  const [showRawData, setShowRawData] = useState(false);

  const egList = useSelector((state) => state.equipmentGroup.equipmentGroupList);
  const customDate = useSelector((state) => state.analyze.searchParams.custom);
  const timeZone = useSelector((state) => state.farm.currentFarm.timezone_identifier);
  // const deviceList = useSelector((state) => state.hardware.deviceList.payload);
  const fieldListById = useSelector((state) => state.equipmentGroup.fieldListById.payload);
  const { payload: egRegionLocation, isRequesting } = useSelector((state) => state.equipmentGroup.EGRegionLocation);
  const { payload: egRegionLocationLog, isRequesting: isRequestingLog } = useSelector((state) => state.equipmentGroup.EGRegionLocationLog);
  const [sort, setSort] = useState({
    direction: 1,
    field: null
  });
  const [filteredData, setFilteredData] = useState([]);
  const [selectedEg, setSelectedEg] = useState(null);


  /*   const deviceNames = deviceList && deviceList.length > 0 ?
      deviceList.reduce((obj, item) => {
        obj[item.deviceId] = item.deviceName;
        return obj;
      }, {}) : {}; */


  const formatedEgLocation = useMemo(() => {
    let res = selectedEg && selectedEg.length > 0 ?
      selectedEg.map((e) => {
        return egRegionLocation[e.value] && egRegionLocation[e.value].length > 0 ? formatEgEvents(egRegionLocation[e.value]) : []
      }) : [];

    res = res.length > 0 ? res.flat() : [];
    res = res.length > 0 ? formatEgEventPair(res) : [];
    return res.sort((a, b) => b.ts - a.ts);
  }, [egRegionLocation, selectedEg]);

  useEffect(() => {
    dispatch(leftSideToggle());
    if (params.farmId) {
      dispatch(getDeviceList(params.farmId))
      dispatch(getGeoRegionList({ farmId: params.farmId }))
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(leftSideToggle());
    }
  }, []);


  function formatEgEvents(data) {
    return data.map((e) => ({
      equipment_group_uuid: e.gps && e.gps.equipment_group ?
        e.gps.equipment_group.equipment_group_uuid : null,
      equipment_group_name: e.gps && e.gps.equipment_group ?
        e.gps.equipment_group.equipment_group_name : 'Unknown',
      location_change_type: e.location_change_type,
      // device_uuid: e.gps ? e.gps.device_id : null,
      // device_name: e.gps && e.gps.device_id && deviceNames ? deviceNames[e.gps.device_id] : 'Unknown',
      geo_region_uuid: e.geo_region_uuid,
      geo_region_name: e.geo_shape_uuid && fieldListById &&
        fieldListById[e.geo_shape_uuid] ? fieldListById[e.geo_shape_uuid].geo_region_name : 'Unknown',
      geo_shape_uuid: e.geo_shape_uuid,
      geo_shape_name: e.geo_shape_uuid && fieldListById &&
        fieldListById[e.geo_shape_uuid] ? fieldListById[e.geo_shape_uuid].geo_shape_name : 'Unknown',
      ts: e.gps ? e.gps.ts : null,
      geo_region_type_id: e.geo_shape_uuid && fieldListById &&
        fieldListById[e.geo_shape_uuid] ? fieldListById[e.geo_shape_uuid].geo_region_type_id : 0
    }))
  }

  function formatEgEventPair(data) {
    const events = getPair(data).sort((a, b) => a.ts - b.ts);
    const result = [];
    for (var i = 0; i < events.length; i++) {
      if (events[i] && events[i + 1]) {
        result.push({
          ...events[i + 1],
          enter_ts: events[i].ts,
          exit_ts: events[i + 1].ts
        })
        i++;
      }
    }
    return result;
  }

  function getPair(data, loopDone = false) {
    const result = [];
    let obj = { enter: null, exit: null };
    let prevShapeName = data[0].geo_shape_name;


    for (const [index, item] of data.sort((a, b) => a.ts - b.ts).entries()) {
      const { geo_shape_name, location_change_type } = item;

      if (prevShapeName !== geo_shape_name) {
        if (obj.enter && obj.exit) result.push(...[obj.enter, obj.exit]);
        obj = { enter: null, exit: null };
      }

      if (location_change_type === 'enter' && !obj.enter) obj.enter = item;
      else if (location_change_type === 'exit') obj.exit = item;

      prevShapeName = geo_shape_name;

      if (index === data.length - 1) {
        if (obj.enter && obj.exit) result.push(...[obj.enter, obj.exit]);

      }
    }
    if (!loopDone) {
      return getPair(result, true)
    }

    return result
  }

  useEffect(() => {
    const { farmId } = params;
    const egListPrams = {
      farmId: farmId,
      crew: 0,
      device: 0
    };
    dispatch(getEquipmentGroupList(egListPrams));
  }, [customDate]);

  useEffect(() => {
    if (selectedEg) {
      const egIds = selectedEg.map((e) => e.value);
      const { farmId } = params;
      for (const egId of egIds) {
        const egLocationPrams = {
          farm_uuid: farmId,
          equipment_group_uuid: egId,
          start_date: dateToUTC(customDate.from, timeZone).format(),
          end_date: dateToUTC(customDate.to, timeZone).format()
        };
        dispatch(getEGRegionLocation(egLocationPrams));
        dispatch(getEGRegionLocationLog({
          ...egLocationPrams,
          start_date: customDate.from,
          end_date: customDate.to
        }));
      }
    }
  }, [selectedEg, customDate]);

  const renderSortOrder = sortField => {
    const { direction, field } = sort;

    if (sortField !== field || direction === 1) return <i className="fa fa-caret-down sort-direction hidden" aria-hidden="true" />;
    if (direction === 1) return <i className="fa fa-caret-down sort-direction hidden" aria-hidden="true" />;
    if (direction === 2) return <i className="fa fa-caret-down sort-direction px-2" aria-hidden="true" />;
    if (direction === 0) return <i className="fa fa-caret-up sort-direction px-2" aria-hidden="true" />;
  }

  const handleSort = (sortField, body, key) => {
    if (!sortField) return;

    let sortedList = [];
    const { direction } = sort;
    let sortDirection = ((direction + 1) > 2) ? 0 : direction + 1;

    if (!direction) sortedList = formatedEgLocation;

    sortedList = body.sort((a, b) => {
      const x = String(a[sortField]).toLowerCase();
      const y = String(b[sortField]).toLowerCase();

      const desc = direction === 2 ? 1 : -1
      const asc = direction === 2 ? -1 : 1

      return (x > y) ? desc : ((y > x) ? asc : 0)
    });

    setFilteredData(sortedList)
    setSort({ direction: sortDirection, field: key });
  };

  //######################### RAW DATA #####################
  const rawHistory = {
    title: "EG Region Location",
    type: "eg_region_location",
    header: [
      { id: 1, key: "sno", label: "#", isSort: false },
      { id: 2, key: "egName", label: "EG", isSort: true },
      { id: 3, key: "geoRegionName", label: "Region", isSort: true },
      { id: 4, key: "entryTs", label: "Enter", isSort: true },
      { id: 5, key: "exitTs", label: "Exit", isSort: true }
    ],
    body: []
  }

  const getRawData = useMemo(() => {
    let rawData = {};
    if (Object.entries(egRegionLocationLog).length > 0) {
      for (const obj in egRegionLocationLog) {
        const item = egRegionLocationLog[obj];
        const result = [];
        if (item && item.length > 0) {
          const enterData = item.filter((e) => e.location_change_type === "enter").sort((a, b) => a.gps.ts - b.gps.ts);
          const exitData = item.filter((e) => e.location_change_type === "exit").sort((a, b) => a.gps.ts - b.gps.ts);

          let greatestLength = (enterData.length > exitData.length) ? enterData.length : exitData.length;
          for (let index = 0; index < greatestLength; index++) {
            const entry = enterData[index] ? enterData[index] : null;
            const exit = exitData[index] ? exitData[index] : null;

            const geoShapeId = (entry && entry['geo_shape_uuid']) ? entry['geo_shape_uuid'] : exit['geo_shape_uuid'];
            const egName = (entry && entry['gps']) ? entry['gps']['equipment_group']['equipment_group_name'] : exit['gps']['equipment_group']['equipment_group_name'];

            const entryTs = (entry && entry['gps']) ? entry['gps']['ts'] : null;
            const exitTs = (exit && exit['gps']) ? exit['gps']['ts'] : null;

            const entryCreatedTs = (entry && entry['@timestamp']) ? entry['@timestamp'] : null;
            const exitCreatedTs = (exit && exit['@timestamp']) ? exit['@timestamp'] : null;

            let resObj = {
              entryTs,
              exitTs,
              entryCreatedTs,
              exitCreatedTs,
              geoRegionName: geoShapeId && fieldListById &&
                fieldListById[geoShapeId] ? fieldListById[geoShapeId].geo_region_name : 'Unknown',
              egName,
              geo_region_type_id: geoShapeId && fieldListById &&
                fieldListById[geoShapeId] ? fieldListById[geoShapeId].geo_region_type_id : 0
            }

            if (entryTs && exitTs) {
              if (entryTs < exitTs) {
                result.push({ ...resObj, createdTs: exitCreatedTs })
              }

              if (entryTs > exitTs) {
                result.push({ ...resObj, entryTs: null, entryCreatedTs: null, createdTs: exitCreatedTs });
                result.push({ ...resObj, exitTs: null, exitCreatedTs: null, createdTs: entryCreatedTs });
              }
            } else if (entryTs && !exitTs) {
              result.push({ ...resObj, exitTs: null, exitCreatedTs: null, createdTs: entryCreatedTs });
            } else if (!entryTs && exitTs) {
              result.push({ ...resObj, entryTs: null, entryCreatedTs: null, createdTs: exitCreatedTs });
            }
          }
          rawData[obj] = result;
        }
      }
    }

    let finalData = [];
    if (selectedEg && egRegionLocationLog && showRawData) {
      selectedEg.forEach(item => {
        const egValue = rawData[item.value] ? rawData[item.value] : [];
        if (egValue.length > 0) finalData = [...finalData, ...egValue];
      });
    };
    return finalData.sort((a, b) => new Date(b.createdTs).valueOf() - new Date(a.createdTs).valueOf());
  }, [egRegionLocationLog, selectedEg, showRawData]);

  const getOrderedData = (data) => {
    let tmpData = data.map((e) => {
      const ts = (e && e['gps']) ? e['gps']['ts'] : null;
      const geoShapeId = (e && e['geo_shape_uuid']) ? e['geo_shape_uuid'] : null;
      const egName = (e && e['gps']) ? e['gps']['equipment_group']['equipment_group_name'] : null;
      return {
        ...e,
        geoRegionName: geoShapeId && fieldListById &&
          fieldListById[geoShapeId] ? fieldListById[geoShapeId].geo_region_name : 'Unknown',
        egName,
        ts,
        geo_region_type_id: geoShapeId && fieldListById &&
          fieldListById[geoShapeId] ? fieldListById[geoShapeId].geo_region_type_id : 0
      }
    })    
    return tmpData.sort((a, b) => new Date(b['@timestamp']).valueOf() - new Date(a['@timestamp']).valueOf());
  };

  const getEnterExitData = useMemo(() => {
    let rawData = {};
    if (Object.entries(egRegionLocationLog).length > 0) {
      for (const obj in egRegionLocationLog) {
        const item = egRegionLocationLog[obj];
        if (item && item.length > 0) {
          let enterData = getOrderedData(item.filter((e) => e.location_change_type === "enter"));
          let exitData = getOrderedData(item.filter((e) => e.location_change_type === "exit"));
          rawData = {
            ...rawData,
            [obj]: {
              enterData,
              exitData
            }
          }
        }
      }
    }

    let finalData = {};
    if (selectedEg && egRegionLocationLog && showRawData && Object.entries(rawData).length > 0) {
      selectedEg.forEach(item => {
        const egValue = rawData[item.value] ? rawData[item.value] : {};
        if (Object.entries(egValue).length > 0) {
          const entry = (finalData && finalData['enterData']) ? finalData['enterData'] : [];
          const exit = (finalData && finalData['exitData']) ? finalData['exitData'] : [];
          finalData = {
            enterData: [...entry, ...egValue['enterData']].sort((a, b) => new Date(b['@timestamp']).valueOf() - new Date(a['@timestamp']).valueOf()),
            exitData: [...exit, ...egValue['exitData']].sort((a, b) => new Date(b['@timestamp']).valueOf() - new Date(a['@timestamp']).valueOf())
          }
        }
      });
    };
    return finalData;
  }, [egRegionLocationLog, selectedEg, showRawData]);

  const getDateTime = (ts) => {
    return ts ? moment.utc(ts).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC) : '-'
  }
  const getLogWorkSheets = () => {
    if (locationLogLength() > 0) {
      let body = getRawData;
      body = body.map((list) => {
        return {
          ...list,
          entryTs: getDateTime(list.entryTs),
          exitTs: getDateTime(list.exitTs)
        }
      })
      return <Workbook.Sheet key={rawHistory.type} data={body} name={rawHistory.title}>
        {rawHistory.header.sort((a, b) => a.id - b.id).map((item, i) => <Workbook.Column key={i} value={item.key} label={item.label} />)}
      </Workbook.Sheet>
    }
  }

  const locationLogLength = () => {
    return Object.keys(egRegionLocationLog).length
  }

  //######################### RAW DATA #####################

  const egRegionLocationData = filteredData.length > 0 ? filteredData : formatedEgLocation;

  const getWorkSheets = () => {
    if (egRegionLocationData.length > 0) {
      const excelData = {
        title: "EG Region Location",
        type: "eg_region_location",
        header: [
          { id: 1, key: "equipment_group_name", label: "EG Name" },
          { id: 2, key: "geo_shape_name", label: "Field Name" },
          { id: 3, key: "spent_time", label: "Spent Time" },
          { id: 4, key: "enter_ts", label: "Enter Time" },
          { id: 5, key: "exit_ts", label: "Exit Time" },
        ],
        body: egRegionLocationData.map((e) => (
          {
            ...e, spent_time: toDisplayTimeString(secondsToTime((moment(e.exit_ts).diff(e.enter_ts) / 1000), true)),
            enter_ts: moment.utc(e.enter_ts).tz(timeZone).format(DISPLAY_DATETIMESECONDS_FORMAT2),
            exit_ts: moment.utc(e.exit_ts).tz(timeZone).format(DISPLAY_DATETIMESECONDS_FORMAT2),
          })
        )
      }

      return <Workbook.Sheet key={excelData.type} data={excelData.body} name={excelData.title}>
        {excelData.header.sort((a, b) => a.id - b.id).map((item, i) => <Workbook.Column key={i} value={item.key} label={item.label} />)}
      </Workbook.Sheet>
    }
  }



  return (
    <Container fluid className='p-5'>
      <Col className='col-12 bg-white' style={{ height: "max-content" }}>
        <div style={{
          width: "100%",
          display: "flex",
          padding: "10px 20px",
          justifyContent: "space-between",
          height: "max-content"
        }} >
          <div><h5>EG Region Location</h5></div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <div className='mt-2'>
              <label className='mr-2'>{showRawData ? "Hide All Events" : "Show All Events"}</label>
              <ToggleSwitch
                className={(showRawData) ? "toggle-switch-fade" : "toggle-switch"}
                title={showRawData ? "Hide All Events" : "Show All Events"}
                onChange={(e) => setShowRawData(!showRawData)}
                checked={showRawData}
              />
            </div>
            <div style={{ width: "300px" }}>
              {egList.length > 0 && <>
                <Select
                  isMulti
                  value={selectedEg}
                  isSearchable={true}
                  name="eg"
                  options={egList.filter((e) => e.vehicle && e.vehicle.is_truck).map((e) => (
                    {
                      value: e.equipment_group_uuid,
                      label: e.equipment_group_name
                    }
                  ))}
                  onChange={(values) => setSelectedEg(values)}
                  placeholder="Select EG.."
                />
              </>}
            </div>

            {(showRawData && locationLogLength() > 0) && <div>
              <Workbook filename={params.farmId && customDate ? `${params.farmId}-${customDate.from}-${customDate.to}.xlsx` : `${Date.now().toString()}.xlsx`}
                element={<Button size="sm" disabled={locationLogLength() === 0} className="mr-2">
                  <i className="fa fa-cloud-download" /> Download</Button>}>
                {getLogWorkSheets()}
              </Workbook>
            </div>}

            {(!showRawData && egRegionLocationData.length > 0) && <Workbook filename={params.farmId && customDate ? `${params.farmId}-${customDate.from}-${customDate.to}.xlsx` : `${Date.now().toString()}.xlsx`}
              element={<Button size="sm" disabled={egRegionLocationData.length === 0} className="mr-2">
                <i className="fa fa-cloud-download" /> Download</Button>}>
              {getWorkSheets()}
            </Workbook>}
          </div>
        </div></Col>
      <div className='bg-white overflow-auto' style={{ height: "calc(100vh - 200px)" }}>
        <Row className='container-row w-100  m-0 p-0 h-auto' style={{ overflow: 'unset' }}>
          {!showRawData && <Col className='container-col col-12 rounded'>
            <div className='mt-3'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>#</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort('equipment_group_name', egRegionLocationData, 'equipment_group_name')}
                    >EG Name <span>{renderSortOrder('equipment_group_name')}</span></th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort('geo_shape_name', egRegionLocationData, 'geo_shape_name')}
                    >Field Name <span>{renderSortOrder('geo_shape_name')}</span></th>
                    <th>Spent Time</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort('ts', egRegionLocationData, 'ts')}
                    >Date <span>{renderSortOrder('ts')}</span></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !isRequesting && egRegionLocationData && egRegionLocationData.map((eg, index) => (
                      <tr style={{ backgroundColor: eg.geo_region_type_id === 4 ? '#00000017' : 'white' }} key={index}>
                        <td>{index + 1}</td>
                        <td>{eg.equipment_group_name}</td>
                        <td>{eg.geo_shape_name}</td>
                        <td>{toDisplayTimeString(secondsToTime((moment(eg.exit_ts).diff(eg.enter_ts) / 1000), true))}</td>
                        <td>{moment.utc(eg.enter_ts).tz(timeZone).format(DISPLAY_DATETIMESECONDS_FORMAT2)} <i className='fa fa-long-arrow-right i-arrow' /> {moment.utc(eg.exit_ts).tz(timeZone).format(DISPLAY_DATETIMESECONDS_FORMAT2)}</td>
                      </tr>
                    ))
                  }
                  {!isRequesting && egRegionLocationData.length === 0 && <tr ><td colSpan={7} className='text-center'>Data not found</td></tr>}
                  {isRequesting && <tr ><td colSpan={7} className='text-center'>Loading...</td></tr>}
                </tbody>
              </table>
            </div>

          </Col>}
          {showRawData && <Col className='container-col d-flex'>
            <Col className='col-12'>
              <div className='d-flex'>
                <Col className='col-8'>
                  <div className='mt-3'>
                    <table className='table'>
                      <thead>
                        <tr>
                          {rawHistory.header.map((item, index) => {
                            return <th key={index}
                              style={{ cursor: item.isSort ? "pointer" : "" }}
                              onClick={() => item.isSort ? handleSort(item['key'], getRawData, item['key']) : ''}
                            >{item.label} {item.isSort && <span>{renderSortOrder(item['key'])}</span>}</th>
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {
                          !isRequestingLog && getRawData && getRawData.map((eg, index) => (
                            <tr style={{ backgroundColor: eg.geo_region_type_id === 4 ? '#00000017' : 'white' }} key={index}>
                              <td>{index + 1}</td>
                              <td>{eg.egName}</td>
                              <td>{eg.geoRegionName}</td>
                              <td>{eg.entryTs ? moment.utc(eg.entryTs).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC) : '-'}{eg.entryTs && eg.entryCreatedTs && ` @ ${moment.utc(eg.entryCreatedTs).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC)}`}</td>
                              <td>{eg.exitTs ? moment.utc(eg.exitTs).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC) : '-'}{eg.exitTs && eg.exitCreatedTs && ` @ ${moment.utc(eg.exitCreatedTs).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC)}`}</td>
                            </tr>
                          ))
                        }
                        {!isRequestingLog && getRawData.length === 0 && <tr ><td colSpan={7} className='text-center'>Data not found</td></tr>}
                        {isRequestingLog && <tr ><td colSpan={7} className='text-center'>Loading...</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </Col>
                <Col className='col-2'>
                  <div className='mt-3'>
                    <table className='table'>
                      <thead>
                        <tr>
                          <th>Entry</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          !isRequestingLog && getEnterExitData && getEnterExitData.enterData && getEnterExitData.enterData.map((eg, index) => (
                            <tr style={{ backgroundColor: eg.geo_region_type_id === 4 ? '#00000017' : 'white' }} key={index}>
                              {/*  <td>{eg.egName}</td> */}
                              {/*  <td>{eg.geoRegionName}</td> */}
                              <td> <span>{eg.egName} - {eg.geoRegionName}</span> <br />
                                <span><b>{eg.ts ? moment.utc(eg.ts).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC) : '-'}</b></span><br />
                                {eg.ts && <span>{` @ ${moment.utc(eg["@timestamp"]).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC)}`}</span>}
                              </td>
                            </tr>
                          ))
                        }
                        {!isRequestingLog && getRawData.length === 0 && <tr ><td colSpan={7} className='text-center'>Data not found</td></tr>}
                        {isRequestingLog && <tr ><td colSpan={7} className='text-center'>Loading...</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </Col>
                <Col className='col-2'>
                  <div className='mt-3'>
                    <table className='table'>
                      <thead>
                        <tr>
                          {/* <th>EG Name</th> */}
                          {/* <th>Region</th> */}
                          <th>Exit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          !isRequestingLog && getEnterExitData && getEnterExitData.exitData && getEnterExitData.exitData.map((eg, index) => (
                            <tr style={{ backgroundColor: eg.geo_region_type_id === 4 ? '#00000017' : 'white' }} key={index}>
                              {/*  <td>{eg.egName}</td> */}
                              {/*  <td>{eg.geoRegionName}</td> */}
                              <td> <span>{eg.egName} - {eg.geoRegionName}</span> <br />
                                <span><b>{eg.ts ? moment.utc(eg.ts).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC) : '-'}</b></span> <br />
                                {eg.ts && <span>{` @ ${moment.utc(eg["@timestamp"]).tz(timeZone).format(DISPLAY_DATE_WITH_MIN_SEC_MSEC)}`}</span>}
                              </td>
                            </tr>
                          ))
                        }
                        {!isRequestingLog && getRawData.length === 0 && <tr ><td colSpan={7} className='text-center'>Data not found</td></tr>}
                        {isRequestingLog && <tr ><td colSpan={7} className='text-center'>Loading...</td></tr>}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </div>
            </Col>

          </Col>}
        </Row>
      </div>
    </Container >
  )
}

export default EgRegionLocation;